<div class="px-5">
    <h1>Cotizaciones</h1>
    <app-admin-table #table [mapHeader]="mapHeader" [queryset]="data$" [exportFile]="'Cotizaciones'" [botones]="botones"></app-admin-table>
</div>
